const okkid = require('./components');

const req = require.context('./components', true, /^\.\/locale\/.+_.+\.tsx$/);

okkid.locales = {};

req.keys().forEach(mod => {
  const matches = mod.match(/\/([^/]+).tsx$/);
  okkid.locales[matches[1]] = req(mod).default;
});

module.exports = okkid;
